import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

interface Order {
  proposalId: string
  isModalOpen: boolean
  setModalIsOpen: (open: boolean) => void
  setProposalId: (proposalId: string) => void
}

const useStoreBase = create<Order>()((set) => ({
  proposalId: '',
  isModalOpen: false,
  setModalIsOpen: (isModalOpen: boolean) => set(() => ({ isModalOpen })),
  setProposalId: (proposalId: string) => set(() => ({ proposalId }))
}))

export const usePendingReviewModalStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<Order>
